import EnhancedSEO from '@/components/seo/EnhancedSEO';
import SupportHero from '@/components/support/SupportHero';
import AudienceSelector from '@/components/support/AudienceSelector';
import ResourceCategories from '@/components/support/ResourceCategories';
import SearchSection from '@/components/support/SearchSection';
import PopularResources from '@/components/support/PopularResources';
import ContactSection from '@/components/support/ContactSection';
import { SupportProvider } from '@/contexts/SupportContext';

const Support = () => {
  return (
    <SupportProvider>
      <EnhancedSEO 
        title="Support Center - Guides, FAQs & Resources"
        description="Find guides, FAQs, and tutorials for older adults, families, caregivers. Your complete support hub for thriving at home."
        keywords="senior care support, aging in place guides, family caregiving resources, professional caregiver tools, sponsor resources, help center"
        canonical="https://seniorthrive.com/support"
        breadcrumbs={[
          { name: "Home", url: "https://seniorthrive.com/" },
          { name: "Support", url: "https://seniorthrive.com/support" }
        ]}
      />
      
      <SupportHero />
      <AudienceSelector />
      <SearchSection />
      <ResourceCategories />
      <PopularResources />
      <ContactSection />
    </SupportProvider>
  );
};

export default Support;